import RoutesInstance from "@routes/instances";
import { IMenuItem } from "./types";
import { BiCar, BiCategory, BiImage, BiPurchaseTag } from "react-icons/bi";
import { FiMonitor } from "react-icons/fi";
import { TbBoxModel2 } from "react-icons/tb";
import { MdOutlineArticle } from "react-icons/md";
import { AiOutlineFileExcel } from "react-icons/ai";

export const MenuItems: Array<IMenuItem> = [
    {
        text: "دسته بندی",
        route: RoutesInstance.categories,
        checkActiveType: "equal",
        Icon: BiCategory,
    },
    {
        text: "برند ها",
        route: RoutesInstance.brands,
        checkActiveType: "equal",
        Icon: BiCar,
    },
    {
        text: "برچسب ها",
        route: RoutesInstance.tags,
        checkActiveType: "equal",
        Icon: BiPurchaseTag,
    },
    {
        text: "پلتفرم ها",
        route: RoutesInstance.platforms,
        checkActiveType: "equal",
        Icon: TbBoxModel2,
    },
    {
        text: "مقاله ها",
        route: RoutesInstance.articles,
        checkActiveType: "equal",
        Icon: MdOutlineArticle,
    },
    {
        text: "محصولات",
        route: RoutesInstance.products,
        checkActiveType: "equal",
        Icon: FiMonitor,
    },
    {
        text: "گالری",
        route: RoutesInstance.gallery,
        checkActiveType: "equal",
        Icon: BiImage,
    },
    {
        text: "اکسل",
        route: RoutesInstance.excel,
        checkActiveType: "equal",
        Icon: AiOutlineFileExcel,
    },
];
